import React from 'react'
import ReactDOM from 'react-dom/client'
import '@rb/design-tokens/tokens.css'
import '@rb/design-tokens/colors-and-type.css'
import App from './App'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
